<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="h2"><a id="preface03"></a><a id="page_xx"><strong>Leaf and Flower Terminology</strong></a></p><a id="page_xx">
</a><p class="imagen"><a id="page_xx"></a><a id="page_xxi"><img alt="Image" src="images/img-1.jpg" width="550px"/></a></p><a id="page_xxi">
</a></div><a id="page_xxi">
<p class="image"><img alt="Image" src="images/img-2.jpg" width="550px"/></p>
</a><p class="image"><a id="page_xxi"></a><a id="page_xxii"><img alt="Image" src="images/img-3a.jpg" width="550px"/></a></p><a id="page_xxii">
<p class="imagen"><img alt="Image" src="images/img-3b.jpg" width="550px"/></p>
</a><div style="height: 550px"><a id="page_xxii">
</a><p class="image"><a id="page_xxii"></a><a id="page_xxiii"><img alt="Image" height="100%" src="images/fxxiii-01.jpg"/></a></p><a id="page_xxiii">
</a></div><a id="page_xxiii">
</a><p class="image"><a id="page_xxiii"></a><a id="page_xxiv"><img alt="Image" src="images/fxxiv-01.jpg" width="550px"/></a></p><a id="page_xxiv">
</a><p class="image"><a id="page_xxiv"></a><a id="page_xxv"><img alt="Image" src="images/fxxiv-06.jpg" width="550px"/></a></p><a id="page_xxv">
</a><div style="height: 550px; text-align: center"><a id="page_xxv"></a><a id="page_xxvi"><img alt="Image" height="100%" src="images/f0xxv-01.jpg"/></a></div><a id="page_xxvi">
</a><p class="image"><a id="page_xxvi"></a><a id="page_xxvii"><img alt="Image" src="images/fxxvi-01a.jpg" width="550px"/></a></p><a id="page_xxvii">
<div style="height: 550px; text-align: center"><img alt="Image" height="100%" src="images/fxxvi-01b.jpg"/></div>
<div style="height: 550px; text-align: center"><img alt="Image" height="100%" src="images/img-4.jpg"/></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// preface03.vue?45c35a50